// declare immutable objects
export const authProtectedRoutes = Object.freeze(['/users'] as const);

export const profileProtectedRoute = Object.freeze(['/profile'] as const);
